import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { LocalCache, StableCache } from '@nk/caching-lib';
import {
  CompanyCollateralAggregateEntity,
  CompanyCollateralComposite,
  CompanyCollateralCreditorEntity,
  CompanyCollateralTypeEntity,
  SimpleCollection,
  WithUuid,
} from '@nk/data-entities-lib';

export interface CollateralApiService {
  companyCollateralAggregateByCompanyCache: LocalCache<
    CollateralApiService,
    (
      companyUuid: string,
      includeCorporateGroup: boolean,
      quarterlyDataPoints: boolean,
      collateralTypeUuid: string | null,
      fromDate: Date | null,
    ) => Observable<CompanyCollateralAggregateEntity[]>
  >;
  companyCollateralTypeListCache: LocalCache<
    CollateralApiService,
    () => Observable<WithUuid<CompanyCollateralTypeEntity>[]>
  >;
  companyCollateralCreditorListCache: StableCache<
    CollateralApiService,
    (companyCollateralCreditorUuids?: string[]) => Observable<WithUuid<CompanyCollateralCreditorEntity>[]>
  >;
  companyCollateralCompositeCollection: LocalCache<
    CollateralApiService,
    (
      companyIdentifier: string,
      showForCorporateGroup: boolean | null,
      includeDeletedCollateral: boolean | null,
      limit: number,
      offset: number,
    ) => Observable<SimpleCollection<WithUuid<CompanyCollateralComposite>>>
  >;
}

export const COLLATERAL_API_SERVICE_TOKEN = new InjectionToken<CollateralApiService>('CollateralApiService');
